import React from 'react';
export function EducationSection() {
  const education = [{
    id: 1,
    school: 'UC Santa Cruz',
    degree: 'Electrical Engineering',
    period: 'Sep 2024 - Present',
    details: ['Sophomore Standing', 'Major: Electrical Engineering'],
    image: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80'
  }, {
    id: 2,
    school: 'Leigh High School',
    degree: 'High School Diploma',
    period: '2020 - 2024',
    details: ['San Jose, CA'],
    image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1771&q=80'
  }];
  return <section id="education" className="section-spacing bg-background-dark" data-id="element-13">
      <div className="container-padding max-w-7xl mx-auto" data-id="element-14">
        <h2 className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-15">
          Education
        </h2>
        <p className="text-text-secondary mb-12 max-w-2xl" data-id="element-16">
          Academic background and qualifications
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-17">
          {education.map(edu => <div key={edu.id} className="card overflow-hidden hover:translate-y-[-5px]" data-id="element-18">
              <div className="flex flex-col md:flex-row" data-id="element-19">
                <div className="md:w-1/3 aspect-square md:aspect-auto" data-id="element-20">
                  <img src={edu.image} alt={edu.school} className="w-full h-full object-cover" data-id="element-21" />
                </div>
                <div className="p-6 md:w-2/3" data-id="element-22">
                  <h3 className="text-xl font-display font-bold mb-1" data-id="element-23">
                    {edu.school}
                  </h3>
                  <p className="text-primary mb-2" data-id="element-24">{edu.degree}</p>
                  <p className="text-text-secondary mb-4" data-id="element-25">{edu.period}</p>
                  <ul className="list-disc pl-5 text-text-secondary" data-id="element-26">
                    {edu.details.map((item, index) => <li key={index} className="mb-1" data-id="element-27">
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}